import Banner from "../../components/banner/Banner"
import CasesList from "../../components/cases/Cases"
import "./cases.scss"

const Cases = () => {
  return (
    <div className="cases">
        <Banner title="Cases"/>
        <CasesList/>
    </div>
  )
}

export default Cases